import HTMLClass from "./HTMLClass";

export default class LoadingHelper
{
    constructor()
    {
        this._loader;
    }

    showLoader(container)
    {
        const el = document.createElement('div');
        HTMLClass.addClass(el, 'js-loading');
        el.innerHTML = 'Loading...';
        container.append(el);
        this._loader = el;
    }

    hideLoader()
    {
        this._loader.parentNode.removeChild(this._loader);
    }

    message(container, text, type = 'info')
    {
        const el = document.createElement('div');
        HTMLClass.addClass(el, 'alert');
        HTMLClass.addClass(el, type);
        el.innerHTML = text;
        container.append(el);

        setTimeout(() => {
            el.parentNode.removeChild(el);
        }, 5000);
    }
}